module.exports = __webpack_public_path__ + "img/Wp_2045.75bb8aa2.png";